<tiime-input-container contentId="body" label="Message" [errorMessage]="form.bodyErrorMessage?.message" required="true">
  <textarea
    id="body"
    placeholder="Message"
    cdkTextareaAutosize
    cdkAutosizeMaxRows="6"
    cdkAutosizeMinRows="3"
    [formControl]="form.body"
  ></textarea>
</tiime-input-container>
